import type { TalentTree } from '../../CharacterTypes';

export const MAGE_TALENTS: TalentTree = {
    'arcane': [
      {
        id: 'mage_intelligence',
        name: 'Intelligence Training',
        description: 'Increase intelligence by 4 per rank',
        icon: '/icons/mage_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'intelligence', value: 4, perRank: true }
        ]
      },
      {
        id: 'mage_wisdom',
        name: 'Wisdom Training',
        description: 'Increase wisdom by 4 per rank',
        icon: '/icons/mage_wisdom.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['mage_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'wisdom', value: 4, perRank: true }
        ]
      },
      {
        id: 'mage_arcane_potency',
        name: 'Arcane Potency',
        description: 'Increase magic attack by 3 per rank',
        icon: '/icons/mage_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['mage_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'magicAttack', value: 3, perRank: true }
        ]
      },
      {
        id: 'mage_spell_critical',
        name: 'Spell Critical',
        description: 'Increase critical chance by 2% per rank',
        icon: '/icons/mage_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['mage_arcane_potency'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.02, perRank: true }
        ]
      },
      {
        id: 'mage_arcane_barrier',
        name: 'Arcane Barrier',
        description: 'Increase magic defense by 4 per rank',
        icon: '/icons/mage_wisdom.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['mage_wisdom'],
        effects: [
          { type: 'stat_bonus', target: 'magicDefense', value: 4, perRank: true }
        ]
      },
      {
        id: 'mage_archmage_mind',
        name: 'Archmage Mind',
        description: 'Increase intelligence by 6 per rank',
        icon: '/icons/mage_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['mage_spell_critical'],
        effects: [
          { type: 'stat_bonus', target: 'intelligence', value: 6, perRank: true }
        ]
      },
      {
        id: 'mage_mana_shielding',
        name: 'Mana Shielding',
        description: 'Increase maximum health by 40 per rank',
        icon: '/icons/mage_wisdom.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['mage_arcane_barrier'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 40, perRank: true }
        ]
      }
    ]
};

export const PRIEST_TALENTS: TalentTree = {
    'holy': [
      {
        id: 'priest_intelligence',
        name: 'Spiritual Insight',
        description: 'Increase intelligence by 2 per rank',
        icon: '/icons/priest_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'intelligence', value: 2, perRank: true }
        ]
      },
      {
        id: 'priest_faith',
        name: 'Deep Faith',
        description: 'Increase magic defense by 3 per rank',
        icon: '/icons/priest_faith.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['priest_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'magicDefense', value: 3, perRank: true }
        ]
      },
      {
        id: 'priest_divine_potency',
        name: 'Divine Potency',
        description: 'Increase magic attack by 3 per rank',
        icon: '/icons/priest_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['priest_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'magicAttack', value: 3, perRank: true }
        ]
      },
      {
        id: 'priest_sacred_shield',
        name: 'Sacred Shielding',
        description: 'Increase maximum health by 40 per rank',
        icon: '/icons/priest_faith.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['priest_faith'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 40, perRank: true }
        ]
      },
      {
        id: 'priest_grace',
        name: 'Grace',
        description: 'Increase intelligence by 5 per rank',
        icon: '/icons/priest_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['priest_divine_potency'],
        effects: [
          { type: 'stat_bonus', target: 'intelligence', value: 5, perRank: true }
        ]
      }
    ]
};

export const WARLOCK_TALENTS: TalentTree = {
    'affliction': [
      {
        id: 'warlock_intelligence',
        name: 'Fel Intellect',
        description: 'Increase intelligence by 2 per rank',
        icon: '/icons/warlock_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'intelligence', value: 2, perRank: true }
        ]
      },
      {
        id: 'warlock_corruption',
        name: 'Master of Corruption',
        description: 'Increase magic attack by 3 per rank',
        icon: '/icons/warlock_corruption.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['warlock_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'magicAttack', value: 3, perRank: true }
        ]
      },
      {
        id: 'warlock_demon_armor',
        name: 'Demon Armor',
        description: 'Increase defense by 4 per rank',
        icon: '/icons/warlock_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['warlock_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'defense', value: 4, perRank: true }
        ]
      },
      {
        id: 'warlock_soul_leech',
        name: 'Soul Leech',
        description: 'Increase maximum health by 40 per rank',
        icon: '/icons/warlock_corruption.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['warlock_corruption'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 40, perRank: true }
        ]
      },
      {
        id: 'warlock_dark_mastery',
        name: 'Dark Mastery',
        description: 'Increase magic attack by 5 per rank',
        icon: '/icons/warlock_corruption.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['warlock_corruption'],
        effects: [
          { type: 'stat_bonus', target: 'magicAttack', value: 5, perRank: true }
        ]
      }
    ]
};
